import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

const CombinedTitleElement = z.enum(['Text', 'Image']);

export const CombinedTitleWidgetStaticSchema = BaseWidgetSchema(WidgetType.CombinedTitle).extend({
  children: z.array(z.string()).optional(), // `children` is optional because it is not used in the CombinedTitle's `create` function
  imageWidgetId: z.string(),
  textWidgetId: z.string(),
  imageWidth: z.number(),
  imageHeight: z.number(),
  elements: z.array(CombinedTitleElement),
  style: z.record(z.unknown())
});

export type CombinedTitleWidgetStaticSchemaType = z.infer<typeof CombinedTitleWidgetStaticSchema>;
